<div class="header">
    <h2>{{ 'milkrun.transportation-requests.line-requests.title' | translate }}</h2>
</div>
<app-transport-requests-table
    class="content"
    [transports]="toolReturns"
    [tableConfig]="tableConfig"
    [isLoading]="isLoading"
    (loadTransportAtLine)="onLoadToolReturn($event)"
    (unloadTransportAtLine)="onUnloadToolReturn($event)"
    (pageChange)="onPageChange($event)">
</app-transport-requests-table>
<app-confirmation-modal
    (confirmEvent)="onConfirmAction($event)"
    [confirmOnlyMode]="true"
    [isConfirmationInProgress]="isLoading"
    [confirmButtonDisabled]="hasConfirmationInProgress"
    [title]="'milkrun.transportation-requests.line-requests.confirmation.popupTitle' | translate"
    [question]="'milkrun.transportation-requests.line-requests.confirmation.popupQuestion' | translate"
    [message]="'milkrun.transportation-requests.line-requests.confirmation.popupMessage' | translate">
</app-confirmation-modal>
